var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('b-alert',{attrs:{"show":_vm.alertCountdown,"dismissible":"","fade":"","variant":_vm.alertType},on:{"dismiss-count-down":_vm.countDownChanged}},[_vm._v(" "+_vm._s(_vm.alertText)+" ")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePage-layout"},[_c('h3',[_vm._v("Home page")])])
}]

export { render, staticRenderFns }